<script lang="ts" setup>
import { computed } from 'vue';
import { NotificationUpdateThemeFeedType } from '@/types';
import { formatThemeName } from '@/utils/formatters';
import CardTemplate from './card-template.vue';

interface Props {
  notification: NotificationUpdateThemeFeedType;
  isUnread: boolean;
}

const props = defineProps<Props>();

const url = computed(() =>
  props.notification.theme.is_deleted
    ? undefined
    : `/themes/${props.notification.theme.id}`,
);
const formattedThemeName = computed(() =>
  formatThemeName(
    props.notification.theme.name,
    props.notification.theme.is_deleted,
  ),
);
</script>
<template>
  <CardTemplate
    :type="notification.type"
    :url="url"
    :is-unread="isUnread"
    :created-at="notification.created_at"
    >{{ `テーマ「${formattedThemeName}」を更新しました。` }}
  </CardTemplate>
</template>
